import styles from './widget_wrapper.module.scss';
import React from 'react';

interface OwnProps {
    children: React.ReactNode;
}

export function WidgetWrapper({children}: OwnProps) {
    return <div className={styles.widget_wrapper}>{children}</div>;
}
